import React from 'react';
import Icon from './Icon';

export default Icon(<path d="M14.9,14.2l-3.8-4.4c0.8-1,1.2-2.3,1.2-3.6C12.3,2.8,9.5,0,6.1,0S0,2.8,0,6.1s2.8,6.1,6.1,6.1c1.1,0,2.2-0.3,3.1-0.8l3.8,4.4c0.2,0.2,0.5,0.2,0.7,0l1.1-1C15,14.7,15.1,14.4,14.9,14.2z M2,6.1C2,3.8,3.8,2,6.1,2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S2,8.5,2,6.1z" />, '0 0 15 16', 'SearchIcon');
